import { render } from "./PersonalTutorTile.vue?vue&type=template&id=56ade9b4"
import script from "./PersonalTutorTile.vue?vue&type=script&lang=js"
export * from "./PersonalTutorTile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__